import React from 'react'
import { Redirect } from 'react-router-dom'
import validations from '../helper/validationHelper'
import errorHandlerHelper from '../helper/errorHandlerHelper';


class Login extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            email: '',
            password: '',
            emailCSS: 'input',
            passwordCSS: 'input',
            buttonCSS: 'button is-success'
        }

        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleEmailChange = this.handleEmailChange.bind(this)
        this.handlePasswordChange = this.handlePasswordChange.bind(this)
    }
    async handleSubmit(event) {
        try {
            event.preventDefault()
            this.setState({buttonCSS : 'button is-success is-loading'})
            let isValidEmail = validations.validateEmail(this.state.email)
            let isValidPassword = validations.validatePassword(this.state.password)
            if (!isValidPassword) {
                this.props.showToast('error', 'Minimum password length is five!')
            }
            if (!isValidEmail) {
                this.props.showToast('error', 'Please enter a valid email!')
            }
            let isValidData = isValidPassword && isValidEmail
            if (isValidData && this.state.email && this.state.password) {
                let payLoad = {
                    email: this.state.email,
                    password: this.state.password
                }
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payLoad)
                }
                const response = await fetch(process.env.REACT_APP_DOMAIN + 'login', requestOptions)
                const data = await response.json()
                if (response.ok) {
                    this.props.setToken(data.token)
                }
                else {
                    errorHandlerHelper.errorHandler(response, data, this.props.logout, this.props.history, this.props.showToast)
                }
            }
        }
        catch (err) {
            this.props.showToast('error', 'Something Went Wrong')
        }
        finally{
            this.setState({buttonCSS : 'button is-success'})
        }
    }
    handleEmailChange(event) {
        if (!validations.validateEmail(event.target.value)) {
            this.setState({
                email: event.target.value,
                emailCSS: 'input is-danger'
            })
        }
        else {
            this.setState({
                email: event.target.value,
                emailCSS: 'input is-success'
            })
        }
    }
    handlePasswordChange(event) {
        if (!validations.validatePassword(event.target.value)) {
            this.setState({
                password: event.target.value,
                passwordCSS: 'input is-danger'
            })
        }
        else {
            this.setState({
                password: event.target.value,
                passwordCSS: 'input is-success'
            })
        }
    }
    render() {
        if (this.props.isLoggedIn) {
            return <Redirect to='/notes'></Redirect>
        }
        return (
            <section className="hero is-fullheight-with-navbar">
                <div className="hero-body">
                    <div className="container is-max-desktop">
                        <div className="card">
                            <header className="card-header">
                                <p className="card-header-title is-centered is-size-3">Login</p>
                            </header>
                            <div className="card-content">
                                <div className="content">
                                    <form onSubmit={this.handleSubmit}>
                                        <div className="field">
                                            <p className="control has-icons-left">
                                                <input className={this.state.emailCSS} type="email" placeholder="Email" value={this.state.email} onChange={this.handleEmailChange} />
                                                <span className="icon is-small is-left">
                                                    <i className="fas fa-envelope"></i>
                                                </span>
                                            </p>
                                        </div>
                                        <div className="field">
                                            <p className="control has-icons-left">
                                                <input className={this.state.passwordCSS} type="password" placeholder="Password" value={this.state.password} onChange={this.handlePasswordChange} />
                                                <span className="icon is-small is-left">
                                                    <i className="fas fa-lock"></i>
                                                </span>
                                            </p>
                                        </div>
                                        <div className="field">
                                            <p className="control">
                                                <button className={this.state.buttonCSS} type="submit">
                                                    Login
                                                </button>
                                            </p>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default Login